// 在文件顶部导入必要的组件
import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import AdminLayout from '@/components/admin/layout/AdminLayout.vue'
import TeacherLayout from '@/views/teacher/TeacherLayout.vue'
import StudentLayout from '@/views/student/layout/StudentLayout.vue' // Updated to the correct directory name

// 公共路由
const publicRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index/home/Index.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/mo_course',
    name: 'mo_course',
    component: () => import('@/views/index/mo_course/Index.vue'),
    meta: { title: '全部课程' }
  },
  {
    path: '/mo_course/detail/:id',
    name: 'mo_courseDetail',
    component: () => import('@/views/index/mo_course/Detail.vue'),
    meta: { title: '课程详情' }
  },
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: () => import('@/views/login/Index.vue'),
    meta: { title: '管理员登录', hideHeader: true, hideFooter: true }
  },
  {
    path: '/teacher/login',
    name: 'teacherLogin',
    component: () => import('@/views/login/TeacherLogin.vue'),
    meta: { title: '教师登录', hideHeader: true, hideFooter: true }
  },
  {
    path: '/student/login',
    name: 'studentLogin',
    component: () => import('@/views/login/StudentLogin.vue'),
    meta: { title: '学生登录', hideHeader: true, hideFooter: true }
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('@/views/index/course/List.vue'),
    meta: { title: '公开课' }
  },
  {
    path: '/course/:id',
    name: 'courseDetail',
    component: () => import('@/views/index/course/Detail.vue'),
    meta: { title: '课程详情' }
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/views/index/live/List.vue'),
    meta: { title: '云课直播' }
  },
  {
    path: '/live/:id',
    name: 'liveDetail',
    component: () => import('@/views/index/live/Detail.vue'),
    meta: { title: '直播详情' }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/index/news/List.vue'),
    meta: { title: '新闻资讯' }
  },
  {
    path: '/news/:id',
    name: 'newsDetail',
    component: () => import('@/views/index/news/Detail.vue'),
    meta: { title: '资讯详情' }
  },
  {
    path: '/course/play/:id',
    name: 'coursePlay',
    component: () => import('@/views/index/course/Play.vue'),
    meta: { title: '课程播放' }
  },
  {
    path: '/school',
    name: 'schoolSelect',
    component: () => import('@/views/login/schoolSelect.vue'),
    meta: { title: '学校选择' }
  },
  {
    path: '/document/:key',
    name: 'DocumentDetail',
    component: () => import('@/views/index/document/Detail.vue'),
    meta: { title: '文档详情' }
  },
]

// 需要登录才能访问的路由
const privateRoutes = [
  /* 暂时注释掉缺失的组件路由
  {
    path: '/routes/booking/:id',
    name: 'routeBooking',
    component: () => import('@/views/routes/Booking.vue'),
    meta: { title: '预订线路', auth: true }
  }
  */
]

const routes = [...publicRoutes, ...privateRoutes,
  // 通配符路由，匹配所有未定义的路径
  {
    path: '/:pathMatch(.*)*',
    redirect: (to) => {
      // 如果路径包含 admin，跳转到 admin/home
      if (to.path.includes('/admin')) {
        return '/admin/home'
      }
      // 否则跳转到首页
      return '/'
    },
  },
  // 添加学生路由配置
  {
    path: '/student',
    name: 'Student',
    component: StudentLayout,
    redirect: '/student/home',
    meta: { title: '学生系统' },
    children: [
      {
        path: 'home',
        name: 'StudentHome',
        component: () => import('../views/student/pages/StudentHome.vue'), // Updated to 'student' directory
        meta: { title: '学生首页' }
      },
      {
        path: 'personal-settings',
        name: 'PersonalSettings',
        component: () => import('../views/student/pages/PersonalSettings.vue'), // Updated to 'student' directory
        meta: { title: '个人设置' }
      },
      {
        path: 'course-detail/:id',
        name: 'CourseDetail',
        component: () => import('@/views/student/pages/course/CourseDetail.vue'), // Updated to 'student' directory
        meta: { title: '课程详情' }
      },
      // 在学生路由的children数组中添加以下代码
      {
        path: 'homework-detail-record',
        name: 'HomeworkDetailRecord',
        component: () => import('../views/student/pages/course/HomeworkDetailRecord.vue'),
        meta: {
          title: '作业详情记录',
          requiresAuth: true
        }
      },
      {
        path: '/student/exam-detail-record',
        name: 'ExamDetailRecord',
        component: () => import('@/views/student/pages/course/ExamDetailRecord.vue'),
        meta: {
          title: '考试详情记录'
        }
      },
      {
        path: 'pages/TopicDiscussion',
        name: 'TopicDiscussion',
        component: () => import('../views/student/pages/TopicDiscussion.vue'),
        meta: { title: '主题讨论' }
      },
      { path: 'happy-circle', name: 'StudentHappyCircle', component: () => import('../views/student/pages/HappyCircle.vue'), meta: { title: '乐学圈' } },
      { path: 'my-courses', name: 'MyCourses', component: () => import('../views/student/pages/MyCourses.vue'), meta: { title: '我的课程' } },
      { 
        path: 'question-bank',
        name: 'StudentQuestionBank',
        component: () => import('../views/student/pages/exam/QuestionBank.vue'), // Updated to 'student' directory
        meta: { title: '我的题库' }
      },
      { 
        path: 'account-security',
        name: 'StudentAccountSecurity',
        component: () => import('../views/student/pages/account/AccountSecurity.vue'), // Updated to 'student' directory
        meta: { title: '账号安全' } 
      },
      { 
        path: 'change-phone',
        name: 'StudentChangePhone',
        component: () => import('../views/student/pages/account/ChangePhone.vue'), // Updated to 'student' directory
        meta: { title: '修改手机号' } 
      },
      { 
        path: 'change-email',
        name: 'StudentChangeEmail',
        component: () => import('../views/student/pages/account/ChangeEmail.vue'), // Updated to 'student' directory
        meta: { title: '修改电子邮箱' } 
      },
      { 
        path: 'message-notification',
        name: 'StudentMessageNotification',
        component: () => import('../views/student/pages/notification/MessageNotification.vue'), // Updated to 'student' directory
        meta: { title: '消息通知' } 
      },
      {
        path: 'message-detail/:id',
        name: 'StudentMessageDetail',
        component: () => import('../views/student/pages/notification/MessageDetail.vue'),
        meta: { title: '消息详情' }
      },
      {
        path: 'change-password',
        name: 'StudentChangePassword',
        component: () => import('../views/student/pages/account/ChangePassword.vue'), // Updated to 'student' directory
        meta: { title: '修改密码' }
      },
      // 添加课程学习页面路由
      { 
        path: 'course-study',
        name: 'CourseStudy',
        component: () => import('../views/student/pages/course/CourseStudy.vue'),
        meta: { title: '课程学习' }
      },
      // 添加课程学习记录页面路由
      { 
        path: 'course-study-record',
        name: 'CourseStudyRecord',
        component: () => import('../views/student/pages/course/StudyRecord.vue'),
        meta: { title: '学习成绩' }
      },
      // 在学生路由配置中添加 ExamPage 路由
      {
        path: 'exam-page',
        name: 'ExamPage',
        component: () => import('../views/student/pages/exam/ExamPage.vue'),
        meta: { 
          title: '考试页面',
          requiresAuth: true // 添加认证要求
        }
      },
      {
        path: 'homework-page',
        name: 'HomeworkPage',
        component: () => import('../views/student/pages/homework/HomeworkPage.vue'),
        meta: { 
          title: '作业页面',
          requiresAuth: true 
        }
      },
      // 添加HomeworkDetail路由
      {
        path: 'homework-detail',
        name: 'HomeworkDetail',
        component: () => import('../views/student/pages/homework/HomeworkDetail.vue'),
        meta: { 
          title: '作业答题详情',
          requiresAuth: true 
        }
      },
      {
        path: 'exam-detail',
        name: 'ExamDetail',
        component: () => import('../views/student/pages/exam/ExamDetail.vue'),
        meta: {
          title: '考试详情',
          requiresAuth: true
        }
      }
    ]
  },
  {
    // 教师页面路由
    path: '/teacher',
    component: TeacherLayout,
    redirect: '/teacher/home',
    meta: { title: '教师系统' },
    children: [
      {
        path: 'home',
        name: 'TeacherHome',
        component: () => import('@/views/teacher/TeacherHome.vue'),
        meta: { title: '教师首页' }
      },
      {
        path: 'template',
        name: 'TeacherTemplate',
        component: () => import('@/views/teacher/TeacherTemplate.vue'),
        meta: { title: '教师页面模板' }
      },
      {
        path: 'courses',
        name: 'TeacherCourses',
        component: () => import('@/views/teacher/TeacherHome.vue'), // 临时使用首页组件
        meta: { title: '我的课程' }
      },
      {
        path: 'students',
        name: 'TeacherStudents',
        component: () => import('@/views/teacher/TeacherHome.vue'), // 临时使用首页组件
        meta: { title: '学生管理' }
      },
      {
        path: 'resources',
        name: 'TeacherResources',
        component: () => import('@/views/teacher/TeacherHome.vue'), // 临时使用首页组件
        meta: { title: '资源库' }
      },
      {
        path: 'settings',
        name: 'TeacherSettings',
        component: () => import('@/views/teacher/TeacherTemplate.vue'),
        meta: { title: '系统设置' }
      },
      {
        path: 'content/course-template',
        name: 'CourseTemplateTeacher',
        component: () => import('@/views/teacher/content/CourseTemplateTeacher.vue'),
        meta: { title: '院校课程模板' }
      },
      {
        path: 'content/course-template-form',
        name: 'CourseTemplateForm',
        component: () => import('@/views/teacher/content/CourseTemplateForm.vue'),
        meta: { title: '添加/编辑课程模板' }
      },
      {
        path: 'content/course-management',
        name: 'CourseManagement',
        component: () => import('@/views/teacher/content/CourseManagement.vue'),
        meta: { title: '课程管理' }
      },
      {
        path: 'content/enrollment-records',
        name: 'EnrollmentRecords',
        component: () => import('@/views/teacher/content/EnrollmentRecords.vue'),
        meta: { title: '选课记录' }
      },
      {
        path: 'content/course-statistics',
        name: 'CourseStatistics',
        component: () => import('@/views/teacher/content/CourseStatistics.vue'),
        meta: { title: '选课统计' }
      },
      {
        path: 'content/open-course',
        name: 'TeacherOpenCourse',
        component: () => import('@/views/teacher/content/OpenCourse.vue'),
        meta: { title: '公开课' }
      },
      {
        path: 'content/open-course-period/:id',
        name: 'TeacherOpenCoursePeriodDetail',
        component: () => import('@/views/teacher/content/OpenCourseRelated/OpenCoursePeriodDetail.vue'),
        meta: { title: '公开课期数详情' }
      },
      {
        path: 'content/opencourse-related/open-video-player',
        name: 'OpenVideoPlayer',
        component: () => import('@/views/teacher/content/OpenCourseRelated/OpenVideoPlayer.vue'),
        meta: { title: '公开课视频播放' }
      },
      {
        path: 'content/opencourse-related/open-materials',
        name: 'OpenMaterials',
        component: () => import('@/views/teacher/content/OpenCourseRelated/OpenMaterials.vue'),
        meta: { title: '公开课资料' }
      },
      {
        path: 'content/opencourse-related/open-external-links',
        name: 'OpenExternalLinks',
        component: () => import('@/views/teacher/content/OpenCourseRelated/OpenExternalLinks.vue'),
        meta: { title: '公开课外链' }
      },
      {        
        path: 'content/course-management/:id',
        name: 'CourseManagementDetail',
        component: () => import('@/views/teacher/content/CourseManagementDetail.vue'),
        meta: { title: '课程详情' }
      },
      {
        path: 'content/video-player',
        name: 'VideoPlayer',
        component: () => import('@/views/teacher/content/courseNodeSynthesis/VideoPlayer.vue'),
        meta: { title: '视频播放' }
      },
      {
        path: 'content/materials',
        name: 'Materials',
        component: () => import('@/views/teacher/content/courseNodeSynthesis/Materials.vue'),
        meta: { title: '课程资料' }
      },
      {
        path: 'content/external-links',
        name: 'ExternalLinks',
        component: () => import('@/views/teacher/content/courseNodeSynthesis/ExternalLinks.vue'),
        meta: { title: '外部链接' }
      },
      {
        path: 'content/work-exam-manage',
        name: 'WorkExamManage',
        component: () => import('@/views/teacher/content/courseNodeSynthesis/WorkExamManage.vue'),
        meta: { title: '作业/考试管理' }
      },
      {
        path: 'content/courseNodeSynthesis/work-exam-preview',
        name: 'WorkExamPreview',
        component: () => import('@/views/teacher/content/courseNodeSynthesis/WorkExamPreview.vue'),
        meta: { title: '作业/考试预览' }
      },
      {        path: 'content/question-management',
        name: 'QuestionManagement',
        component: () => import('@/views/teacher/content/QuestionManagement.vue'),
        meta: { title: '试题管理' }
      },
      {
        path: 'content/paper-management',
        name: 'PaperManagement',
        component: () => import('@/views/teacher/content/PaperManagement.vue'),
        meta: { title: '试卷管理' }
      },
      {
        path: 'content/paper-detail/:id',
        name: 'PaperDetail',
        component: () => import('@/views/teacher/content/PaperDetail.vue'),
        meta: { title: '试卷详情' }
      },
      {
        path: 'content/happy-circle',
        name: 'HappyCircle',
        component: () => import('@/views/teacher/content/HappyCircle.vue'),
        meta: { title: '乐学圈' }
      },
      {
        path: 'content/message-push',
        name: 'MessagePush',
        component: () => import('@/views/teacher/content/MessagePush.vue'),
        meta: { title: '消息推送' }
      },
      {
        path: 'content/teacher-news',
        name: 'TeacherNews',
        component: () => import('@/views/teacher/content/TeacherNews.vue'),
        meta: { title: '教学新闻' }
      },
      {
        path: 'content/course-class-management',
        name: 'CourseClassManagement',
        component: () => import('@/views/teacher/content/courseDetailExpansion/ClassManagement.vue'),
        meta: { title: '课程班级管理' }
      },
      {
        path: 'userAccountManagement/TeacherPersonalInformation',
        name: 'TeacherPersonalInformation',
        component: () => import('@/views/teacher/userAccountManagement/TeacherPersonalInformation.vue'),
        meta: { title: '修改个人信息' }
      },
      {
        path: 'userAccountManagement/TeacherPasswordChanged',
        name: 'TeacherPasswordChanged',
        component: () => import('@/views/teacher/userAccountManagement/TeacherPasswordChanged.vue'),
        meta: { title: '修改账号密码' }
      },
      {
        path: 'userAccountManagement/TeacherAdminManagement',
        name: 'TeacherAdminManagement',
        component: () => import('@/views/teacher/userAccountManagement/TeacherAdminManagement.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'userAccountManagement/TeacherRoleManagement',
        name: 'TeacherRoleManagement',
        component: () => import('@/views/teacher/userAccountManagement/TeacherRoleManagement.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'userAccountManagement/TeacherRolePermissionSetting',
        name: 'TeacherRolePermissionSetting',
        component: () => import('@/views/teacher/userAccountManagement/TeacherRolePermissionSetting.vue'),
        meta: { title: '角色权限设置' }
      },
      {
        path: 'setting/subject-category',
        name: 'TeacherSubjectCategory',
        component: () => import('@/views/teacher/setting/SubjectCategory.vue'),
        meta: { title: '学科分类' }
      },
      {
        path: 'setting/banner-management',
        name: 'TeacherBannerManagement',
        component: () => import('@/views/teacher/setting/BannerManagement.vue'),
        meta: { title: '首页轮播图管理' }
      },
      {
        path: 'setting/muted-management',
        name: 'TeacherMutedManagement',
        component: () => import('@/views/teacher/setting/MutedManagement.vue'),
        meta: { title: '禁言管理' }
      },
      {
        path: 'setting/statistical-report',
        name: 'TeacherStatisticalReport',
        component: () => import('@/views/teacher/setting/StatisticsReport.vue'),
        meta: { title: '统计报表' }
      },
      {
        path: 'setting/homepage-column',
        name: 'TeacherHomepageColumn',
        component: () => import('@/views/teacher/setting/HomepageColumn.vue'),
        meta: { title: '首页栏位' }
      },

      {
        path: 'collegesAndClasses/college-management',
        name: 'CollegeManagement',
        component: () => import('@/views/teacher/collegesAndClasses/CollegeManagement.vue'),
        meta: { title: '学院管理' }
      },
      {
        path: 'collegesAndClasses/class-management',
        name: 'ClassManagement',
        component: () => import('@/views/teacher/collegesAndClasses/ClassManagement.vue'),
        meta: { title: '班级管理' }
      },
      {
        path: 'collegesAndClasses/student-database',
        name: 'StudentDatabase',
        component: () => import('@/views/teacher/collegesAndClasses/StudentDatabase.vue'),
        meta: { title: '学生信息库' }
      },
      {
        path: 'collegesAndClasses/student-management',
        name: 'StudentManagement',
        component: () => import('@/views/teacher/collegesAndClasses/StudentManagement.vue'),
        meta: { title: '学生管理' }
      },
      {
        path: 'content/courseDetailExpansion/topic-discussion-stats',
        name: 'TopicDiscussionStats',
        component: () => import('@/views/teacher/content/courseDetailExpansion/TopicDiscussionStats.vue'),
        meta: { title: '主题讨论统计' }
      },
      {
        path: 'content/courseDetailExpansion/video-discussion-stats',
        name: 'VideoDiscussionStats',
        component: () => import('@/views/teacher/content/courseDetailExpansion/VideoDiscussionStats.vue'),
        meta: { title: '视频讨论统计' }
      },
      {
        path: 'content/courseDetailExpansion/video-ranking-stats',
        name: 'VideoRankingStats',
        component: () => import('@/views/teacher/content/courseDetailExpansion/VideoRankingStats.vue'),
        meta: { title: '视频排行榜' }
      },
      {
        path: 'content/courseDetailExpansion/course-discussion-details',
        name: 'CourseDiscussionDetails',
        component: () => import('@/views/teacher/content/courseDetailExpansion/CourseDiscussionDetails.vue'),
        meta: { title: '课程讨论详情' }
      },
      {
        path: 'content/courseDetailExpansion/course-discussion-score-stats',
        name: 'CourseDiscussionScoreStats',
        component: () => import('@/views/teacher/content/courseDetailExpansion/CourseDiscussionScoreStats.vue'),
        meta: { title: '讨论情况统计' }
      },
      {
        path: 'content/courseDetailExpansion/work-situation',
        name: 'WorkSituation',
        component: () => import('@/views/teacher/content/courseDetailExpansion/WorkSituation.vue'),
        meta: { title: '作业情况' }
      },
      {
        path: 'content/courseDetailExpansion/course-grades',
        name: 'CourseGrades',
        component: () => import('@/views/teacher/content/courseDetailExpansion/CourseGrades.vue'),
        meta: { title: '课程成绩' }
      },
      {
        path: 'content/courseDetailExpansion/homework-record',
        name: 'HomeworkRecord',
        component: () => import('@/views/teacher/content/courseDetailExpansion/HomeworkRecord.vue'),
        meta: { title: '作业记录' }
      },
      {
        path: 'content/courseDetailExpansion/online-study-record',
        name: 'OnlineStudyRecord',
        component: () => import('@/views/teacher/content/courseDetailExpansion/OnlineStudyRecord.vue'),
        meta: { title: '线上学习记录' }
      },
      {
        path: 'content/courseDetailExpansion/overall-report',
        name: 'OverallReport',
        component: () => import('@/views/teacher/content/courseDetailExpansion/OverallReport.vue'),
        meta: { title: '整体报表' }
      },
      {
        path: 'content/courseDetailExpansion/video-report',
        name: 'VideoReport',
        component: () => import('@/views/teacher/content/courseDetailExpansion/VideoReport.vue'),
        meta: { title: '视频报表' }
      },
      {
        path: 'content/courseDetailExpansion/report-page',
        name: 'ReportPage',
        component: () => import('@/views/teacher/content/courseDetailExpansion/ReportPage.vue'),
        meta: { title: '作业考试报表' }
      }
    ]
  },
  {
    // 管理员路由
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/home',
    children: [
      {
        path: 'home',
        name: 'AdminHome',
        component: () => import('@/views/admin/userInfo/adminhome.vue'),
        meta: { title: '管理员首页' }
      },
      {
        path: 'account',
        name: 'AccountManage',
        redirect: '/admin/account/admin',
        meta: { title: '系统账号管理' },
        children: [
          {
            path: 'profile',
            name: 'modifyInformation',
            component: () => import('@/views/admin/userInfo/adminPersonalInformation.vue'),
            meta: { title: '修改个人信息' }
          },
          {
            path: 'password',
            name: 'changedPassword',
            component: () => import('@/views/admin/userInfo/adminPasswordChanged.vue'),
            meta: { title: '修改账号密码' }
          },
          {
            path: 'admin',
            name: 'AdminManage',
            component: () => import('@/views/admin/userInfo/adminManagement.vue'),
            meta: { title: '管理员管理' }
          },
          {
            path: 'school',
            name: 'SchoolAccountManage',
            component: () => import('@/views/admin/userInfo/schoolAccountManagement.vue'),
            meta: { title: '学校账号管理' }
          },
          {
            path: 'student',
            name: 'StudentAccountManage',
            component: () => import('@/views/admin/userInfo/studentAccountManagement.vue'),
            meta: { title: '学生账号管理' }
          },
          {
            path: 'role',
            name: 'UserRole',
            component: () => import('@/views/admin/userInfo/RoleManagement.vue'),
            meta: { title: '角色管理' }
          },
          {
            path: 'role-permission-settings',
            name: 'RolePermissionSettings',
            component: () => import('@/views/admin/userInfo/RolePermissionSettings.vue'),
            meta: { title: '角色权限设置' }
          }
        ]
      },
      {
        path: 'course',
        name: 'CourseManage',
        redirect: '/admin/course/list',
        meta: { title: '课程管理' },
        children: [
          {
            path: 'list',
            name: 'CourseList',
            component: () => import('@/views/admin/course/List.vue'),
            meta: { title: '课程列表' }
          },
          {
            path: 'category',
            name: 'CourseCategory',
            component: () => import('@/views/admin/course/Category.vue'),
            meta: { title: '课程分类' }
          },
          {
            path: 'template',
            name: 'CourseTemplate',
            component: () => import('@/views/admin/course/Template.vue'),
            meta: { title: '院校课程模板' }
          },
          {
            path: 'template/add',
            name: 'CourseTemplateAdd',
            component: () => import('@/views/admin/course/TemplateForm.vue'),
            meta: { title: '添加课程模板' }
          },
          {
            path: 'template/edit/:id',
            name: 'CourseTemplateEdit',
            component: () => import('@/views/admin/course/TemplateForm.vue'),
            meta: { title: '编辑课程模板' }
          },
          {
            path: 'template/:id',
            name: 'CourseTemplateDetail',
            component: () => import('@/views/admin/course/TemplateDetail.vue'),
            meta: { title: '课程模板详情' }
          },
          {
            path: 'template/video/:id',
            name: 'CourseTemplateVideo',
            component: () => import('@/views/admin/course/VideoPlayer.vue'),
            meta: { title: '视频播放' }
          },
          {
            path: 'template/materials/:id',
            name: 'CourseTemplateMaterials',
            component: () => import('@/views/admin/course/Materials.vue'),
            meta: { title: '课程资料' }
          },
          {
            path: 'template/external-links/:id',
            name: 'CourseTemplateExternalLinks',
            component: () => import('@/views/admin/course/ExternalLinks.vue'),
            meta: { title: '外部链接' }
          },
          {
            path: 'template/homework/:id',
            name: 'CourseTemplateHomework',
            component: () => import('@/views/admin/course/Homework.vue'),
            meta: { title: '课程作业' }
          },
          {
            path: 'template/exam/:id',
            name: 'CourseTemplateExam',
            component: () => import('@/views/admin/course/Exam.vue'),
            meta: { title: '课程考试' }
          },
          {
            path: 'questionbank',
            name: 'QuestionBank',
            component: () => import('@/views/admin/course/QuestionBank.vue'),
            meta: { title: '试题题库' }
          },
          {
            path: 'opencourse',
            name: 'OpenCourse',
            component: () => import('@/views/admin/course/OpenCourse.vue'),
            meta: { title: '公开课' }
          },
          {
            path: 'opencourse-review',
            name: 'OpenCourseAudit',
            component: () => import('@/views/admin/course/opencoursechapter/OpenCourseAudit.vue'),
            meta: { title: '公开课审核' }
          },
          {
            path: 'opencourse/:id',
            name: 'OpenCourseTemplateDetail',
            component: () => import('@/views/admin/course/OpenCourseTemplateDetail.vue'),
            meta: { title: '公开课期数详情' }
          },
          {
            path: 'opencoursechapter/openVideoPlayer',
            name: 'OpenCourseVideoPlayer',
            component: () => import('@/views/admin/course/opencoursechapter/openVideoPlayer.vue'),
            meta: { title: '公开课视频播放' }
          },
          {
            path: 'opencoursechapter/openMaterials',
            name: 'OpenCourseMaterials',
            component: () => import('@/views/admin/course/opencoursechapter/openMaterials.vue'),
            meta: { title: '公开课资料管理' }
          },
          {
            path: 'opencoursechapter/openExternalLinks',
            name: 'OpenCourseExternalLinks',
            component: () => import('@/views/admin/course/opencoursechapter/openExternalLinks.vue'),
            meta: { title: '公开课外链管理' }
          }
        ]
      },
      {
        path: 'content',
        name: 'ContentManage',
        redirect: '/admin/content/news',
        meta: { title: '内容管理' },
        children: [
          {
            path: 'news',
            name: 'NewsManage',
            component: () => import('@/views/admin/content/News.vue'),
            meta: { title: '新闻管理' }
          },
          {
            path: 'live-video',
            name: 'LiveVideoStreaming',
            component: () => import('@/views/admin/content/LiveVideoStreaming.vue'),
            meta: { title: '视频直播' }
          },
          {
            path: 'document',
            name: 'DocumentManagement',
            component: () => import('@/views/admin/content/DocumentManagement.vue'),
            meta: { title: '文档管理' }
          },
          {
            path: 'feedback',
            name: 'Feedback',
            component: () => import('@/views/admin/content/Feedback.vue'),
            meta: { title: '意见反馈' }
          },
          {
            path: 'banner',
            name: 'AdminBannerManagement',
            component: () => import('@/views/admin/content/adminBannerManagement.vue'),
            meta: { title: '首页Banner管理' }
          },
        ]
      },
      {
        path: 'order',
        name: 'OrderManage',
        //redirect: '/admin/order',
        component: () => import('@/views/index/home/Index.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        //redirect: '/admin/statistics',
        component: () => import('@/views/index/home/Index.vue'),
        meta: { title: '统计分析' }
      },
      {
        path: 'settings',
        name: 'Settings',
        redirect: '/admin/settings/banner',
        meta: { title: '系统设置' },
        children: [
          {
            path: 'school',
            name: 'SchoolManage',
            component: () => import('@/views/admin/settings/SchoolManage.vue'),
            meta: { title: '学校管理' }
          },
          {
            path: 'website',
            name: 'WebsiteSettings',
            component: () => import('@/views/admin/settings/WebsiteSettings.vue'),
            meta: { title: '网站基本设置' }
          }
        ]
      },
      {
        path: 'homepage',
        name: 'HomepageManage',
        redirect: '/admin/homepage/topic',
        meta: { title: '首页管理' },
        children: [
          {
            path: 'topic',
            name: 'HomepageTopic',
            component: () => import('@/views/admin/homepage/Topic.vue'),
            meta: { title: '首页专题' }
          },
          {
            path: 'topic/form',
            name: 'TopicAdd',
            component: () => import('@/views/admin/homepage/TopicForm.vue'),
            meta: { title: '新增专题' }
          },
          {
            path: 'topic/form/:id',
            name: 'TopicEdit',
            component: () => import('@/views/admin/homepage/TopicForm.vue'),
            meta: { title: '编辑专题' }
          }
        ]
      },
      
    ]
  }
]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

const getSchoolBranding = () => {
  let schoolTitle = ''
  let schoolIcon = ''
  try {
    const cached = localStorage.getItem('currentSchool')
    if (cached) {
      const parsed = JSON.parse(cached)
      if (parsed && parsed.name) schoolTitle = parsed.name
      if (parsed && (parsed.icon || parsed.favicon || parsed.badge || parsed.logo)) {
        schoolIcon = parsed.icon || parsed.favicon || parsed.badge || parsed.logo
      }
    }
  } catch (e) {
    schoolTitle = ''
    schoolIcon = ''
  }
  return { schoolTitle, schoolIcon }
}

const applySchoolBranding = (route) => {
  const { schoolTitle, schoolIcon } = getSchoolBranding()
  const defaultTitle = schoolTitle || '在线测评考试平台'
  const currentRoute = route || router.currentRoute.value
  const metaTitle = currentRoute && currentRoute.meta ? currentRoute.meta.title : ''
  if (metaTitle) {
    document.title = `${metaTitle} - ${defaultTitle}`
  } else {
    document.title = defaultTitle
  }
  if (schoolIcon) {
    const href = String(schoolIcon)
    const link = document.querySelector('link[rel="icon"]') || document.createElement('link')
    link.setAttribute('rel', 'icon')
    link.setAttribute('href', href)
    if (!link.parentNode) document.head.appendChild(link)
  }
}

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  applySchoolBranding(to)

  // 检查是否需要登录权限
  if (to.meta.auth) {
    const token = localStorage.getItem('token')
    if (!token) {
      // 判断页面类型
      const isAdminPage = to.path.includes('/admin')
      const isTeacherPage = to.path.includes('/teacher')
      
      if (isAdminPage) {
        ElMessage.warning('请先登录')
        next('/admin/login')
      } 
      // else if (isTeacherPage) {
      //   ElMessage.warning('请先登录')
      //   next('/user-login?type=teacher')
      // }
       else {
        // 前台页面静默跳转到首页，不显示提示
        next('/')
      }
      return
    }
    
    // 检查用户类型权限
    // if (to.meta.userType) {
    //   const loginData = localStorage.getItem('loginData')
    //   if (loginData) {
    //     const userData = JSON.parse(loginData)
    //     const userType = userData.userType || userData.type
        
    //     // 如果用户类型不匹配，跳转到对应登录页面
    //     if (to.meta.userType !== userType) {
    //       if (to.meta.userType === 'teacher') {
    //         ElMessage.warning('请使用教师账号登录')
    //         next('/user-login?type=teacher')
    //       } else if (to.meta.userType === 'admin') {
    //         ElMessage.warning('请使用管理员账号登录')
    //         next('/admin/login')
    //       } else {
    //         next('/user-login')
    //       }
    //       return
    //     }
    //   }
    // }
  }
  if (to.path.startsWith('/teacher') && !to.path.startsWith('/teacher/login')) {
    const { useUserStore } = await import('@/stores/user')
    const { getToken } = await import('@/utils/auth')
    const userStore = useUserStore()
    userStore.initializeUserState()
    const loginData = userStore.getLoginData
    const userType = loginData?.userType || loginData?.type
    const tokenValid = !!getToken('user') || !!getToken('admin')
    const timedOut = userStore.checkLoginTimeout()
    if (!tokenValid || timedOut || !(userType === 'teacher' || userType === 'admin')) {
      next('/teacher/login')
      return
    }
    const routeName = to.name
    if (routeName === 'TeacherHome' || to.path === '/teacher/home') {
      next()
      return
    }
    if (routeName && !userStore.hasRouteAccess(routeName)) {
      ElMessage.error('无权限访问该页面')
      next('/teacher/home')
      return
    }
    const requiredPerms = to.meta && Array.isArray(to.meta.requiredPerms) ? to.meta.requiredPerms : []
    if (requiredPerms.length && !userStore.hasAllPermissions(requiredPerms)) {
      ElMessage.error('无权限访问该页面')
      next('/teacher/home')
      return
    }
  }
  if (to.path.startsWith('/admin') && !to.path.startsWith('/admin/login')) {
    const { useUserStore } = await import('@/stores/user')
    const { getToken } = await import('@/utils/auth')
    const userStore = useUserStore()
    userStore.initializeUserState()
    const loginData = userStore.getLoginData
    const userType = loginData?.userType || loginData?.type || userStore.getUserInfo?.userType || userStore.getUserInfo?.role
    const tokenValid = !!getToken('admin')
    const timedOut = userStore.checkLoginTimeout()
    if (!tokenValid || timedOut || userType !== 'admin') {
      next('/admin/login')
      return
    }
  }
  next()
})

export { applySchoolBranding }
export default router

